import { useEffect, useState } from 'react'
import { getUser, showLoader, trimLocation, useAuth, useInstance, useRequest } from '@10000/react'
import { authenticate, base64ToObject } from './request'
import { useShell, useStack } from '../layout'
import { SignUp } from './SignUp'
import { query } from '../../utilities'

export const ExternalUser = ({ active }) => {
  const { replaceStack } = useStack()
  const { setInstance } = useInstance()
  const request = useRequest('tenant')
  const { authenticate: reauthenticate } = useAuth()
  const [error, setError] = useState()

  useShell({ active, mode: 'none' })

  useEffect(() => {
    const { code, state } = query()
    const { free, link } = base64ToObject(state)

    authenticate({ code }, !link)
      .then(async ({ user }) => {
        showLoader()
        trimLocation()

        if (link) {
          const existingUser = getUser()
          await request('socialLoginLinked', { token: user.token })
          await reauthenticate({ provider: 'cognito', username: user.id, refreshToken: user.refreshToken }, true)
          setInstance({ id: existingUser.tenantId, region: existingUser.region })
        } else if (user.tenantId) {
          setInstance({ id: user.tenantId, region: user.region })
        } else {
          replaceStack(SignUp, { props: { external: true, free } })
        }
      })
      .catch(error => {
        setError(error)
        throw error // rethrow this so it gets logged
      })
      .finally(() => showLoader(false))
  }, []) // eslint-disable-line
         // because this needs to only run once and there are some dependencies being difficult

  return error && 'An error occurred verifying the login. Try refreshing the page. ' + (error.message || error)
}